import { render, staticRenderFns } from "./ScrollObserver.vue?vue&type=template&id=56993f52&scoped=true&lang=pug"
import script from "./ScrollObserver.vue?vue&type=script&lang=js"
export * from "./ScrollObserver.vue?vue&type=script&lang=js"
import style0 from "./ScrollObserver.vue?vue&type=style&index=0&id=56993f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56993f52",
  null
  
)

export default component.exports